import { Visible } from 'src/ui/common/layouts/visible';
import styled from 'styled-components';
import { media } from 'src/ui/common/mixins/media';

export const StyledWrapper = styled.div`
  margin-bottom: 20px;
  
  ${media.sm`
    display: flex;
  `}
`;

export const DesktopActions = styled(Visible)`
  max-width: 340px;
  flex: 3;
  margin-left: 10px;
  
  input, svg {
    color: ${({ theme }) => theme.colors.gs200};
  }
  
  ${media.md`
    flex: 0 0 270px;
  `}
`;

export const MobileActions = styled(Visible)`
  margin-top: 5px;

  & button {
    flex: 1;  
  }
  
  & button + button {
    margin-left: 5px;
  }
`;
